import type { MobilisationEvent } from '@hcc/types';
import { ArchivePanel, DeletePanel } from '../../../components/person/PersonDangerPanels';
import { PseudonymisePanel } from '../../../components/person/PseudonymisePanel';
import { SarExportPanel } from '../../../components/person/SarExportPanel';
import type { PersonApi } from './types';

/**
 * GDPR and danger-zone actions. The tab itself is gated by
 * getVisibleTabs; the individual panels narrow further by role
 * (archive: coordinator and up, anonymise / delete: admin only).
 */
export function AdminTab({
  person,
  events,
  roles,
  refreshEvents,
  onGone,
}: {
  person: PersonApi;
  events: MobilisationEvent[] | null;
  roles: string[];
  refreshEvents: () => void;
  /** Called after anonymise / delete removes the record. */
  onGone: () => void;
}) {
  const isCoordinatorUp = roles.some((r) =>
    ['admin', 'super_admin', 'coordinator'].includes(r),
  );
  const isAdmin = roles.includes('admin') || roles.includes('super_admin');

  return (
    <>
      <SarExportPanel personId={person.id} fullName={person.full_name} />
      {isCoordinatorUp ? (
        <ArchivePanel personId={person.id} events={events} onChange={refreshEvents} />
      ) : null}
      {isAdmin ? <PseudonymisePanel personId={person.id} onDone={onGone} /> : null}
      {isAdmin ? (
        <DeletePanel personId={person.id} fullName={person.full_name} onDone={onGone} />
      ) : null}
    </>
  );
}
